<div [ngClass]="loading ? 'visually-hidden': ''">
    <div class="d-flex justify-content-center">
        <div class="text-center">
            <H1 class="text-danger"><i class="fas fa-bomb"></i> OOPS! Error</H1>
            <p class="fs-5" *ngIf="errorMessage">{{errorMessage}}</p>
                <button (click)="goHome();" class=" btn btn-primary btn-lg">Return Home</button>
        </div>
    </div>
</div>